import { Link, useMatch, useResolvedPath } from "react-router-dom";
import { Nav } from "react-bootstrap";
import PropTypes from "prop-types";

const NavLink = ({
	children,
	className,
	endMatch,
	href,
	onClick,
	to
}) => {

	let link = "";

	if (to === "") {
		link = (
			<Nav.Item>
				<Nav.Link
					className={className}
					href={href}
					onClick={onClick}
					target="_blank"
				>
					{children}
				</Nav.Link>
			</Nav.Item>
		);
	} else {

		const resolved = useResolvedPath(to);
		const match = useMatch({
			end: endMatch,
			path: resolved.pathname
		});

		link = (
			<Nav.Item>
				<Nav.Link
					active={match !== null}
					as={Link}
					className={className}
					onClick={onClick}
					to={to}
				>
					{children}
				</Nav.Link>
			</Nav.Item>
		);
	}

	return link;
};

NavLink.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	endMatch: PropTypes.bool,
	href: PropTypes.string,
	onClick: PropTypes.func,
	to: PropTypes.string
};

NavLink.defaultProps = {
	className: "",
	endMatch: false,
	href: "",
	onClick: () => null,
	to: ""
};

export default NavLink;
